import { Injectable } from '@angular/core';
import { AppConfigService } from '../../auth/services/app-config.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface ResponseData {
  label: string,
  data: string,
}

@Injectable({
  providedIn: 'root'
})
export class AddCategoryService {

  private backendUrl: string = `${this.appConfig.config.baseUrl}${this.appConfig.config.backendUrl}`;


  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  constructor(private http: HttpClient, private appConfig: AppConfigService) { }

  addCategory(category: any): Observable<any> {
    return this.http
      .post<ResponseData>(
        `${this.backendUrl}/categories`,
        category,
        {observe: 'response'},
      ).pipe(
        catchError(this.handleError)
      );
  }

  editCategory(categoryList: any): Observable<any> {
    return this.http
      .put<ResponseData>(
        `${this.backendUrl}/categories`,
        categoryList,
        {observe: 'response'},
      ).pipe(
        catchError(this.handleError)
      );
  }

  uploadIcon(id: number, formData: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.set('Content-Type', '');

    return this.http
      .post<any>(
        `${this.backendUrl}/images/icons/${id}`,
        formData,
        {observe: 'response', headers: headers},
      ).pipe(
        catchError(this.handleError)
      );
  }

  uploadMarker(id: number, formData: any) {
    let headers = new HttpHeaders();
    headers.set('Content-Type', '');

    return this.http
      .post<any>(
        `${this.backendUrl}/images/markers/${id}`,
        formData,
        {observe: 'response', headers: headers},
      ).pipe(
        catchError(this.handleError)
      );
  }
}
